export default __webpack_public_path__ + "static/download-app-phone-2-4a69524bad5dddcbd37f9015c5008022.png";